import styled from "styled-components";

const Main = styled.main`
  pointer-events: auto;
  transition: all 1s;
  opacity: 0;
`;

export default Main;
